@if (viewModel$ | async; as viewModel) {
    @if (viewModel.showErrors) {
        @for (error of viewModel.errors; track error) {
            @if (error) {
                <bs-alert [message]="error.message ?? ''" [type]="alertType" />
            }
        }
    }
}
